// Core React imports
import { FacebookContentTag } from "store/platforms/types";
import { useTranslation } from "react-i18next";
import { BaseAutocomplete } from "components/inputs/autocomplete/base-autocomplete";
import { isNullOrWhitespace } from "helpers/strings";

interface ContentTagsSelectorProps {
    availableContentTags: FacebookContentTag[];
    setAvailableContentTags: (tags: FacebookContentTag[]) => void;
    selectedContentTags: FacebookContentTag[];
    setSelectedContentTags: (tags: FacebookContentTag[]) => void;
    tagsLoading: boolean;
    onSearch: (query: string) => unknown;
}

export const ContentTagsSelector = ({
    availableContentTags,
    setAvailableContentTags,
    selectedContentTags,
    setSelectedContentTags,
    tagsLoading,
    onSearch
}: ContentTagsSelectorProps) => {
    const { t } = useTranslation();

    return (
        <div>
            <BaseAutocomplete<FacebookContentTag>
                items={availableContentTags}
                itemIdKey={"id"}
                itemLabelKey={"label"}
                labels={{
                    appliedItemsLabel: t("platforms:content-tags"),
                    noItemsAppliedLabel: t("video-upload:no-tags-applied"),
                    inputLabel: t("facebook-destination:search-tags")
                }}
                assignedItems={selectedContentTags || []}
                variant="search"
                handleAssignItem={(item) => {
                    setSelectedContentTags([
                        ...selectedContentTags.filter((t) => t.id !== item.id),
                        item
                    ]);

                    setAvailableContentTags([]);
                }}
                handleAddItem={(query: string) => {
                    if (isNullOrWhitespace(query) || query.length < 2) {
                        setAvailableContentTags([]);
                        return;
                    }
                    return onSearch(query);
                }}
                itemsLoading={tagsLoading}
                handleRemoveItem={(itemId) => {
                    setSelectedContentTags(
                        selectedContentTags.filter((i) => i.id !== itemId)
                    );
                }}
            />
        </div>
    );
};
